import { I18n } from '@lingui/core';
import {
  ChartDefinition,
  ChartSchema,
  Timezone,
  DateRange,
} from '@/features/report-snapshots/api/schema';
import { Chart } from '@highcharts/react';
import { ChartTitle } from '@/features/report-snapshots/components/charts/chart-title';
import { SeriesChartBuilder } from '@/features/report-snapshots/components/charts/series-chart-builder';
import { ChartType } from '@/features/report-snapshots/types';

interface SeriesChartProps {
  chartSchemas: ChartSchema[];
  chartDefinition: ChartDefinition;
  chartType: ChartType;
  timezone: Timezone;
  i18n: I18n;
  dateRange: DateRange;
}

export const SeriesChart = ({
  chartSchemas,
  chartDefinition,
  timezone,
  i18n,
  chartType,
  dateRange,
}: SeriesChartProps) => {
  const config = SeriesChartBuilder.build(
    chartSchemas,
    chartDefinition,
    chartType,
    timezone,
    i18n,
    dateRange,
  );

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <ChartTitle chartSchema={chartSchemas[0]} chartDefinition={chartDefinition} />
      <div className="flex-1 min-h-0">
        <Chart
          containerProps={{
            className: 'h-full w-full',
          }}
          options={config}
        />
      </div>
    </div>
  );
};
